const initialState = {
    isLoading : true,
    data      : [],
    error     : false,
};

const hotelProfile = (state = initialState, action = { type: null }) => {
    switch (action.type) {
        case 'HOTEL_PROFILE_REQUEST_START':
            return {
                ...state,
                isLoading: true,
            };
        case 'HOTEL_PROFILE_REQUEST_FAILURE':
            return {
                ...state,
                error     : true,
                isLoading : false,
            };
        case 'HOTEL_PROFILE_REQUEST_SUCCESS':
            return {
                ...state,
                isLoading : false,
                data      : action.payload,
                error     : false,
            };
        default:
            return state;
    }
};

export default hotelProfile;
